let UniformStyle = require('./uniform');

const fillColor = "rgba(100,200,255,0.4)";
const strokeColor = "rgba(255,0,255,0.4)";
const width = 1;
const strokeWidth = width * 16;
const pointRadius = width * 20;

const lineCap = "square";
const lineJoin = "bevel";

let styleConfigurations = {};

styleConfigurations.Polygon = {
    fill: {
        color: fillColor
    },
    stroke: {
        width: strokeWidth,
        color: strokeColor,
        lineCap: lineCap,
        lineJoin: lineJoin
    }
};

styleConfigurations.MultiPolygon = styleConfigurations.Polygon;

styleConfigurations.LineString = {
    stroke: {
        color: strokeColor,
        width: strokeWidth,
        lineCap: lineCap,
        lineJoin: lineJoin
    }
};
styleConfigurations.MultiLineString = styleConfigurations.LineString;

styleConfigurations.Point = {
    image: {
        radius: pointRadius,
        fill: {
            color: fillColor
        },
        stroke: {
            color: strokeColor,
            width: strokeWidth,
            lineCap: lineCap,
            lineJoin: lineJoin
        }
    }
};
styleConfigurations.MultiPoint = styleConfigurations.Point;

let defaultStyles = {
    "Point": new UniformStyle(styleConfigurations["Point"]),
    "MultiPoint": new UniformStyle(styleConfigurations["MultiPoint"]),
    "LineString": new UniformStyle(styleConfigurations["LineString"]),
    "MultiLineString": new UniformStyle(styleConfigurations["MultiLineString"]),
    "Polygon": new UniformStyle(styleConfigurations["Polygon"]),
    "MultiPolygon": new UniformStyle(styleConfigurations["MultiPolygon"]),
    "anyGeometryType": new UniformStyle(styleConfigurations["Point"]),
};

module.exports = defaultStyles;